import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

const ShipManagement = () => {
  return (
    <div>

      {/* Hero Section */}
      <section className="service-hero">
        <div className='service-cover-text-ship'>
          <h1>Ship Management</h1>
          <p>Technical Solutions for Peak Vessel Performance</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="service-intro">
        <div className="content">
          <h2>Comprehensive Ship Management Services</h2>
          <p>
            At Blue Waves Ship Management, we offer tailored ship management solutions focused on safety, efficiency, and performance. Our services include <strong>Technical Management</strong> and deep expertise in <strong>Regulatory Compliance</strong> to ensure seamless operations and peace of mind.
          </p>
        </div>
      </section>

      {/* Technical Management */}
      <section className="service-section">
        <div className="service-split">
          <div className="text">
            <h3>⚙️ What is Technical Ship Management?</h3>
            <p>
              Technical ship management involves overseeing all technical aspects of a vessel’s operation, including maintenance, inspections, repairs, and compliance with maritime regulations.
            </p>

            <h4>🌍 Importance for Ship Owners</h4>
            <ul>
              <li><strong>Focus on Core Business:</strong> Delegating technical operations lets owners focus on strategic growth.</li>
              <li><strong>Increased Operational Efficiency:</strong> Scheduled maintenance ensures smoother voyages.</li>
              <li><strong>Improved Safety:</strong> Reduced breakdowns, incidents, and insurance claims.</li>
              <li><strong>Regulatory Compliance:</strong> Avoid legal trouble by staying ahead of laws.</li>
            </ul>

            <h4>🚧 Challenges in Technical Ship Management</h4>
            <ul>
              <li>Keeping pace with evolving international regulations.</li>
              <li>Recruiting and retaining skilled technical personnel.</li>
              <li>Balancing cost efficiency and performance.</li>
            </ul>

            <h4>🧭 How to Choose the Right Management Company</h4>
            <ul>
              <li>🧠 <strong>Understand Your Needs:</strong> Define your vessel and business goals clearly.</li>
              <li>🤝 <strong>Owner's Approach:</strong> Look for partners who act in your best interest.</li>
              <li>🛠️ <strong>Established Processes:</strong> Choose companies with proven SOPs.</li>
              <li>🌐 <strong>Global Reach:</strong> Worldwide support with local expertise is key.</li>
              <li>⚖️ <strong>Cost vs Quality:</strong> Don’t compromise safety or service for price.</li>
            </ul>
          </div>
          <div className="image">
            <img src="/images/technical-management.webp" alt="Technical Management" />
          </div>
        </div>
      </section>

      {/* Regulatory Compliance */}
      <section className="service-section alt">
        <div className="service-split">
          <div className="image">
            <img src="/images/regulatory-compliance.webp" alt="Regulatory Compliance" />
          </div>
          <div className="text">
            <h3>📜 Regulatory Compliance</h3>
            <p>
              Regulatory compliance ensures vessels operate safely, legally, and sustainably. We assist shipowners in adhering to global maritime laws such as IMO, ISM, SOLAS, MARPOL, and MLC.
            </p>

            <h4>🎯 Why Compliance Matters</h4>
            <ul>
              <li>✅ Safer vessels, reduced legal risks.</li>
              <li>✅ Port access and global trade permission.</li>
              <li>✅ Improved audit readiness and inspections.</li>
            </ul>

            <h4>🌀 Common Challenges</h4>
            <ul>
              <li>Constantly evolving laws and international standards.</li>
              <li>Shortage of internal legal/marine expertise.</li>
              <li>High cost of fines, detentions, or lost reputation.</li>
            </ul>

            <h4>🧑‍💼 Role of Marine Consultants</h4>
            <p>
              Marine consultants play a vital role in guiding shipowners through regulatory frameworks. Their services include:
            </p>
            <ul>
              <li>📋 Pre-audit preparation and gap assessments</li>
              <li>📚 Crew and shore team training programs</li>
              <li>📄 Document and safety management systems</li>
              <li>🛟 Environmental and pollution control strategies</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-us">
        <h2>Why Partner with Blue Wave?</h2>
        <div className="why-grid">
          <div className="why-card">
            <h4>🌐 24/7 Global Support</h4>
            <p>Our dedicated technical teams ensure smooth operations—anytime, anywhere.</p>
          </div>
          <div className="why-card">
            <h4>⚓ Trusted Experience</h4>
            <p>We manage tankers, bulkers, and offshore vessels across key global markets.</p>
          </div>
          <div className="why-card">
            <h4>📘 Full Compliance</h4>
            <p>We stay ahead of IMO, ISM, and ISO regulations—so you don’t have to.</p>
          </div>
          <div className="why-card">
            <h4>📊 Smart Reporting</h4>
            <p>Real-time dashboards and automated insights for better decision-making.</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="service-cta">
        <h2>Partner with a Trusted Ship Manager</h2>
        <p>Let Blue Waves handle your technical operations with precision and compliance. Reach out to start a customized partnership.</p>
        <a href="/contact" className="cta-button">Get in Touch</a>
      </section>

      <Footer />
    </div>
  );
};

export default ShipManagement;
